module.exports = __webpack_public_path__ + "static/img/mcx_logo.12f8231.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/mcx_logo.webp
// module id = U+89
// module chunks = 2 8